import { ArrowDownLeft, ArrowUpRight, Check } from "lucide-react";

// Reassure people about the product boundary while authentication is in progress.
export function AuthStory() {
  return (
    <div className="flex max-w-xl flex-col">
      <p className="font-mono text-xs tracking-[0.16em] uppercase opacity-70">
        A family agreement, made visible
      </p>
      <h2 className="mt-5 font-serif text-5xl leading-[1.02] font-semibold">
        One balance.
        <br />
        The whole story.
      </h2>

      <div className="border-primary-foreground/20 bg-primary-foreground/10 mt-10 overflow-hidden rounded-2xl border">
        <div className="border-primary-foreground/20 flex items-end justify-between border-b px-6 py-5">
          <div>
            <p className="text-sm opacity-70">Maya&apos;s ledger</p>
            <p className="mt-1 font-serif text-3xl font-semibold">$18.50</p>
          </div>
          <span className="rounded-full border border-current/25 px-3 py-1 text-xs opacity-75">
            Virtual balance
          </span>
        </div>
        <div className="divide-primary-foreground/15 divide-y px-6">
          <StoryEntry
            amount="+$10.00"
            icon={ArrowDownLeft}
            label="Weekly allowance"
          />
          <StoryEntry amount="−$6.50" icon={ArrowUpRight} label="New book" />
        </div>
      </div>

      <ul className="mt-8 grid gap-3 text-sm opacity-80">
        <li className="flex items-center gap-2">
          <Check className="size-4" /> No bank or card connection
        </li>
        <li className="flex items-center gap-2">
          <Check className="size-4" /> Kids only see what belongs to them
        </li>
        <li className="flex items-center gap-2">
          <Check className="size-4" /> Every entry keeps its author
        </li>
      </ul>
    </div>
  );
}

interface StoryEntryProps {
  amount: string;
  icon: typeof ArrowDownLeft;
  label: string;
}

// Render a simple example that remains understandable without color.
function StoryEntry({ amount, icon: Icon, label }: StoryEntryProps) {
  return (
    <div className="flex h-14 items-center gap-3 text-sm">
      <Icon className="size-4 opacity-70" />
      <span className="flex-1">{label}</span>
      <span className="money-numbers font-semibold">{amount}</span>
    </div>
  );
}
